<template>
    <div class="home-page cg-page">
		<!-- <Header></Header> -->
    <div class="pt20">
    <a class="logo" href="/"><img src="static/images/logo-new.png" /></a>
    </div>
		<div class="content">
      <div class="drop-down-content">
        <div class="login-content">
          <div class="ac fs33 pt20" style="width:80%;margin:30px auto 30px;color:#ffc497;text-transform: uppercase;" v-html="$t('cgtips1')"></div>
          <div class="ac" style="color:#ffc497;width:80%;margin:0 auto 40px;">{{$t('cgtips2')}}</div>
          <div class="input-div">
            <div class="span fs33">{{$t('phoneNumber')}}</div>
            <div class="input-item">
                <span>09</span>
              <input class="input" v-model="mobile" disabled placeholder="">
            </div>
          </div>
          <div class="input-div">
            <div class="span fs33">OTP</div>
            <div class="input-item disflex" style="background: none;">
              <input class="input" v-model="otp" style="width: 100%;height:80px;" placeholder="">
              <button class="btn btn-blue" style="padding: 0 10px;height:75px;width: 210px;margin-left:5px" :class="{disable:codeText != $t('getCode')}" type="none" :disabled="codeText != $t('getCode')" @click="getSendOtp">{{codeText}}</button>
            </div>
          </div>
          <div class="ac mt100" style="margin-top:120px;">
            <button class="btn btn-blue"  style="width:calc(70% - 60px);" @click="goLogin">{{$t('Login')}}</button>
          </div>
          <div class="ac otp-b mt100">
            {{$t('cgtips3')}}
            <router-link class="fs33 opt-a " :to="{path:'/termsAndCondition'}">{{$t('TC')}}</router-link>
            {{$t('cgtips4')}}
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/headerNo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        otp:'',
        codeText:'',
        isReturn:false
      }
    },
    created(){
      this.codeText = this.$t('getCode')
      this.getSendOtp();
      this.mobile = this.$route.query.mobile
    },
    methods: {
    getSendOtp(){
      let that = this
      if(that.isReturn){
        return;
      }
      that.isReturn = true
      let data ={
          'mobile':"09"+this.$route.query.mobile
      }
      that.$api.post('/api/user/send_otp',data,r =>{
        that.$utils.alertText(r.msg,80,3000);
        this.countDown(61,1)
      })
    },
		back(){
			this.$router.go(-1);
		},
		goLogin(){
		  let that = this
		  if(that.mobile==''){
		  	that.$utils.alertText(that.$t('tips'),60)
		  	return;
		  }
      let channel = ''
      if(this.$route.query.channel!=undefined){
        channel = this.$route.query.channel
      }
		  let data ={
		      'mobile':"09"+this.$route.query.mobile,
		      'otp':this.otp,
          'channel':channel,
          'subappid':this.$route.query.subappid,
		  }
      that.$parent.loadModal(true);
		  that.$api.post('/api/user/otp_login',data,r =>{
		  //	that.$parent.returnCode(r,function(){
        that.$parent.loadModal(false);
		    if(r.code==1){
		      localStorage.setItem('token',r.data.userinfo.token)
		      that.isShowlogin = false
		      that.mobile = ''
		      that.otp = ''
          this.$router.push({path:'/'})
		    }else{
		      that.$utils.alertText(r.msg,80);
		    }
		      console.log(r.data.userinfo.token)
		  	//})
		  })
		},
    // 计时
    countDown (miao,type){
    	if(miao === 1){
    		this.codeText = this.$t('getCode');
    		return;
    	}
    	miao--;
    	if(type === 1){
    		this.codeText = miao + "s";
        this.isReturn = false
    	}
    	setTimeout(() =>{
    		this.countDown(miao,type);
    	},1000)
    }
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .input{background:#ffc497;height:70px;border:none;border-radius: 20px;font-size:38px;font-family:MyriadProBold;padding:0 20px;width:80%;color: #280933;}
  .input-div{margin:30px 40px 10px;}
  .input-div .span{margin: 0 auto 10px;width:70%;}
  .input-item{background:#ffc497;border-radius: 20px;height:80px;line-height:80px;width:70%;margin: 0 auto;}
  .input-div div span{font-size:38px;padding-left: 30px;color: #280933;}
  .mt100{margin-top:100px;}
  .opt-a{color: #2d31fa;text-decoration: underline;}
  .btn{line-height:80px;background-color:#ffd024;width:100%;color:#280933;}
  .otp-b{margin:100px 50px 0 ;}
  .cg-page{background:url(../../static/images/Background.png) no-repeat 0 0 #280933;color:#fff}
  .btn.disable{background-color:#d1c185;}
</style>



// WEBPACK FOOTER //
// src/page/sendOtp.vue